import React from "react";
import {
  Box,
  Typography,
  LinearProgress,
  Stack,
  useTheme,
} from "@mui/material";
import { Adjust, AdsClick } from "@mui/icons-material";

interface ProgressBarData {
  label: string;
  value: number;
}

interface ProgressBarChartProps {
  data: ProgressBarData[];
  title?: string;
}

export const ProgressBarChart: React.FC<ProgressBarChartProps> = ({
  data,
  title,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Stack
        spacing={2}
        sx={{ mt: title ? 2 : 0 }}
        flex={1}
        justifyContent="center"
      >
        {data.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 0.5,
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <AdsClick
              sx={{ fontSize: 20, color: theme.palette.text.secondary }}
            />
            <Typography
              variant="body2"
              color="text.secondary"
              flexShrink={0}
              sx={{ width: "40%" }}
            >
              {item.label}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={item.value}
              sx={{
                height: 15,
                width: "100%",
                borderRadius: 1,
                bgcolor: theme.palette.action.hover,
                "& .MuiLinearProgress-bar": {
                  borderRadius: 1,
                  bgcolor: theme.palette.primary.main,
                },
              }}
            />
            <Typography variant="caption" color="text.secondary">
              {item.value}%
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
